export let correct_answer_sound = new Audio("./question-correct.ogg");
export let wrong_answer_sound = new Audio("./question-wrong.wav");
